import deviceApi from '@api/deviceApi';
import DefaultPage from '@components/defaultPage';
import DeviceStateOverview from '@components/deviceStateOverview';
import HistoryWidget from '@components/historyWidget';
import { useTranslator } from '@i18n';
import { createFileRoute } from '@tanstack/react-router';
import { useHandleError } from '@util/errors';
import { LoadingBoundary } from 'cross-state/react';

export const Route = createFileRoute('/inventory/$deviceType/$deviceId/details')({
  component: DeviceDetailsPage,
});

function DeviceDetailsPage() {
  const t = useTranslator();
  const { locationId = '' } = Route.useSearch();
  const { deviceId } = Route.useParams();
  const [device, deviceError] = deviceApi.get(locationId, deviceId).useCache({ loadingBoundary: true });
  useHandleError(deviceError);

  return (
    <DefaultPage
      backButton={{ to: '..' }}
      title={[t('device.details.title'), device ? String(device?.location.sequenceNumber).padStart(4, '0') : ''].join(
        ' ',
      )}
      css={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {!device ? (
        t('device.history.notFound', { id: deviceId })
      ) : (
        <>
          <DeviceStateOverview device={device} />

          <h2
            css={{
              marginTop: 'var(--mantine-spacing-xl)',
            }}
          >
            {t('device.history.title')}
          </h2>

          <LoadingBoundary>
            <HistoryWidget deviceIds={[deviceId]} />
          </LoadingBoundary>
        </>
      )}
    </DefaultPage>
  );
}
